import { render, staticRenderFns } from "./UploadButton.vue?vue&type=template&id=1846efa9&scoped=true&"
var script = {}
import style0 from "./UploadButton.vue?vue&type=style&index=0&id=1846efa9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1846efa9",
  null
  
)

export default component.exports